import { isFunction } from 'lodash';
import postscribe from 'postscribe';
import AbstractDriver from './abstract-driver';

const key = 'GTM-NC66RQ';
const auth = process.env.GOOGLE_TAG_MANAGER_AUTH;
const preview = process.env.GOOGLE_TAG_MANAGER_PREVIEW;

/* global gtag */
/* eslint no-undef: "error" */
class GoogleAnalytics extends AbstractDriver
{
    loaded = false;

    init(config)
    {
        if (this._exists())
        {
            // gtag('config', key, {
            //     send_page_view: false,
            // });
            //
            // if (config.user_id)
            // {
            //     gtag('set', 'user_id', config.user_id);
            // }
        }
        else
        {
            this._loadScript(config);
        }
    }

    async pageView()
    {

    }

    async lead()
    {

    }

    _exists(showErrors = false)
    {
        return this.loaded;
    }

    _loadScript(config)
    {
        if (this._exists()) return false;

        postscribe(document.querySelector('head'), `
            <!-- Google Tag Manager -->
            <script defer type="text/javascript">(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','GTM-NC66RQ');</script>
            <!-- End Google Tag Manager -->

            <!-- Google Tag Manager (noscript) -->
            <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NC66RQ"
                              height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
            <!-- End Google Tag Manager (noscript) -->
        `, {
            done: () =>
            {
                this.loaded = true;
                this.init(config);
            },
        });
    }
}

export default GoogleAnalytics;
